import { detect } from 'detect-browser'

export function isSupportedBrowser() {
  const browser = detect()
  switch (browser && browser.name) {
    case 'chrome':
    case 'firefox':
    case 'edge-chromium':
      return true

    default:
      return false
  }
}
